{
  "INTEGRATION_APPS": {
    "FETCHING": "Загрузка интеграций",
    "NO_HOOK_CONFIGURED": "В этой учетной записи не настроено ни одной {integrationId} интеграции.",
    "HEADER": "Приложения",
    "STATUS": {
      "ENABLED": "Включено",
      "DISABLED": "Выключено"
    },
    "CONFIGURE": "Настроить",
    "ADD_BUTTON": "Добавить новый хук",
    "DELETE": {
      "TITLE": {
        "INBOX": "Подтвердите удаление",
        "ACCOUNT": "Отключиться"
      },
      "MESSAGE": {
        "INBOX": "Вы точно хотите удалить?",
        "ACCOUNT": "Вы уверены, что хотите отключиться?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Да, удалить",
        "ACCOUNT": "Да, отключить"
      },
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Вебхук удален",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      }
    },
    "LIST": {
      "FETCHING": "Получение хуков",
      "INBOX": "Электронная почта",
      "EDIT": {
        "BUTTON_TEXT": "Редактировать"
      },
      "DELETE": {
        "BUTTON_TEXT": "Удалить"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Выбрать \"Входящий\" канал",
          "PLACEHOLDER": "Выбрать \"Входящий\" канал"
        },
        "SUBMIT": "Создать",
        "CANCEL": "Отменить"
      },
      "API": {
        "SUCCESS_MESSAGE": "Вебхук для интеграции успешно добавлен",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      }
    },
    "EDIT": {
      "TITLE": "Редактировать {name}",
      "FORM": {
        "SUBMIT": "Обновить",
        "CANCEL": "Отменить"
      },
      "API": {
        "SUCCESS_MESSAGE": "Хук интеграции успешно обновлён",
        "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Подключить"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Отключиться"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Синхронизируйте электронную почту и веб-чаты с вашим аккаунтом daktela.",
      "RETINO": "Retino упорядочивает управление возвратами и претензиями.",
      "MAILSHIP": "Mailship — система управления складом и выполнением заказов. Уточняйте статус заказа, отслеживание и детали доставки.",
      "RAYNET": "Подключите аккаунт Raynet CRM, чтобы получить доступ к данным клиентов. Добавьте подключение, указав имя пользователя и API-токен Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Проверить подключение",
      "SUCCESS": "Подключение успешно",
      "ERROR": "Не удалось подключиться. Проверьте учётные данные."
    }
  }
}
